import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import Datetime from 'react-datetime';
import { Modal, Col, Row, Form, InputGroup, Button } from 'react-bootstrap';
import { FormValidator } from '../../../helpers/form-validator';
import { toMoment, getDefaultMoment, toApiDateString } from '../../../helpers/moment-ex';
import { Unit } from '../../../helpers/unit';
import { Validator } from '../../widgets';
import { updateCrew, getWorkPlan, updateEndCrew, createCrew } from '../../../actions/crew-kanban';
import { uuid } from "../../../helpers/common";
import { DISPLAY_DATE_FORMAT, DISPLAY_DATETIME_FORMAT2, PLAN_TYPE_LIST } from '../../../constants';
import FieldSelection from "./FieldSelection";
const getRules = (unit, isEndCrew) => {
    const acres = { min: unit.toRoundOfArea(1), max: unit.toRoundOfArea(50000) };
    // const speed = { min: unit.toRoundOfSpeed(0.5), max: unit.toRoundOfSpeed(50) };
    return [
        {
            field: 'crewName',
            method: 'isEmpty',
            validWhen: false,
            message: 'Crew Name is required.',
            group: 'common'
        },
        {
            field: 'plannedAcres',
            method: 'isEmpty',
            validWhen: false,
            message: 'Planned area is required.',
            group: "workplan"
        },
        {
            field: 'plannedAcres',
            method: 'isFloat',
            validWhen: true,
            args: [{ min: acres.min, max: acres.max }],
            validateEmpty: false,
            message: 'Planned area maximum is {max}',
            group: "workplan"
        },
        {
            field: 'utilization',
            method: 'isEmpty',
            validWhen: false,
            message: 'Planned utilization is required.',
            group: "workplan"
        },
        {
            field: 'utilization',
            method: 'isFloat',
            validWhen: true,
            args: [{ min: 1, max: 100 }],
            validateEmpty: false,
            message: 'Planned utilization between {min} and {max}%',
            group: "workplan"
        },
        {
            field: 'avgWorkingSpeed',
            method: 'isEmpty',
            validWhen: false,
            message: 'Planned avg. working speed is required.',
            group: "workplan"
        },
        // {
        // 	field: 'avgWorkingSpeed',
        // 	method: 'isFloat',
        // 	validWhen: true,
        // 	args: [{ min: speed.min, max: speed.max }],
        // 	validateEmpty: false,
        // 	message: 'Planned avg. working speed between {min} and {max}',
        // 	group: "workplan"
        // },
        {
            field: 'workingHoursPerDay',
            method: 'isEmpty',
            validWhen: false,
            message: 'Planned working hours per day is required.',
            group: "workplan"
        },
        // {
        // 	field: 'workingHoursPerDay',
        // 	method: 'isFloat',
        // 	validWhen: true,
        // 	args: [{ min: 1, max: 24 }],
        // 	validateEmpty: false,
        // 	message: 'Planned working hours per day between {min} and {max}',
        // 	group: "workplan"
        // },
        {
            field: 'nonWorkingDays',
            method: 'isInt',
            validWhen: true,
            args: [{ min: 0, max: 50 }],
            validateEmpty: false,
            message: 'Planned non-working days maximum is {max}',
            group: "workplan"
        },
        {
            field: 'startDate',
            method: 'isMoment',
            validWhen: true,
            message: 'Please select start date'
        },
        {
            field: 'endCrewDate',
            method: 'isMoment',
            validWhen: isEndCrew ? true : false,
            message: 'Please select end crew date'
        },
        {
            field: 'acresPerDay',
            method: 'isEmpty',
            validWhen: false,
            message: 'Daily Target acres is required.',
            group: "workplan"
        },
        {
            field: 'workingDays',
            method: 'isEmpty',
            validWhen: false,
            message: 'No of Working days is required.',
            group: "workplan"
        },
        // {
        // 	field: 'truckRate',
        // 	method: 'isEmpty',
        // 	validWhen: true,
        // 	message: 'Truck Rate is required.',
        // 	group: 'common'
        // },
        // {
        // 	field: 'semiTruckRate',
        // 	method: 'isEmpty',
        // 	validWhen: true,
        // 	message: 'Semi truck Rate is required.',
        // 	group: 'common'
        // },
    ];
};

const CrewForm = props => {
    const clearPlanned = {
        plannedAcres: 0,
        acresPerDay: 0,
        isManualPlannedAcre: false,
        selectedFields: [],
        utilization: 0,
        avgWorkingSpeed: 0,
        workingHoursPerDay: 0,
        workingDays: 0,
        nonWorkingDays: 0
    };

    const defaultPlanned = {
        plannedAcres: 1,
        isManualPlannedAcre: false,
        selectedFields: [],
        utilization: 40,
        avgWorkingSpeed: 4,
        acresPerDay: 0,
        workingHoursPerDay: 10,
        workingDays: 1,
        nonWorkingDays: 0
    };

    const { show, onHide } = props;

    const dispatch = useDispatch();
    const crew = props.crewId ? useSelector((state) => state.crewKanban.crews[props.crewId].info) : null;
    const isEditMode = props.crewId ? useSelector((state) => state.crewKanban.crews[props.crewId].isEditMode) : false;
    const planTypeId = useSelector((state) => state.crewKanban.filters.planTypeId);
    const settings = useSelector((state) => state.user.settings);
    const unit = Unit.getInstance();
    const validator = new FormValidator(getRules(unit, (crew && crew.is_end_crew)));
    const [submitted, setSubmitted] = useState(false);
    const [prevPlanned, setPrevPlanned] = useState(null);
    const [state, setState] = useState({
        ...defaultPlanned,
        validation: validator.valid(),
        validateGroup: null,
        crewName: "",
        startDate: null,
        isNoWorkPlan: false,
        isValidateAll: false,
        isEndCrew: null,
        endCrewDate: null,
        loadType: 1,
        workPlanMethodId: 1,
        acresPerDay: 1,
        workingDays: 1,
        targetPlanType: 2,
        truckRate: 'default_option',
        semiTruckRate: 'default_option',
        isAllShapes: false
    });

    useEffect(() => {
        if (crew) bindCrewInfo();
    }, [crew]);

    useEffect(() => {
        if (state.workPlanMethodId === 3) {
            setState({
                ...state,
                plannedAcres: state.acresPerDay * state.workingDays
            });
        }
    }, [state.acresPerDay, state.workingDays, state.workPlanMethodId]);

    useEffect(() => {
        if ((isEditMode && prevPlanned && prevPlanned.workPlanMethodId === state.workPlanMethodId) ||
            (isEditMode && prevPlanned && prevPlanned.workPlanMethodId !== state.workPlanMethodId && show === false) ||
            (!isEditMode && prevPlanned && prevPlanned.workPlanMethodId === state.workPlanMethodId) ||
            (!isEditMode && prevPlanned && prevPlanned.workPlanMethodId !== state.workPlanMethodId && show === false)) {
            setState({
                ...state,
                ...prevPlanned
            })
        }
        else {
            setState({
                ...state, selectedFields: [],
                ...defaultPlanned,
                acresPerDay: 1,
                workingDays: 1
            })
        }

    }, [state.workPlanMethodId, show]);

    useEffect(() => {
        if (crew) {
            setPrevPlanned({
                crewName: crew.crew_name,
                startDate: crew.plan_start_date ? toMoment(crew.plan_start_date) : null,
                loadType: crew.load_type,
                acresPerDay: unit.toRoundOfArea(crew.acres_per_day),
                plannedAcres: unit.toArea(parseFloat(crew.acres), 2),
                isNoWorkPlan: !crew.is_work_plan,
                isManualPlannedAcre: Boolean(crew.is_manual_planned_acres),
                utilization: crew.utilization ? Math.ceil(crew.utilization) : 40,
                avgWorkingSpeed: unit.toSpeed(parseFloat(crew.avg_working_speed), 2),
                workingHoursPerDay: parseFloat(crew.working_hours_per_day),
                workingDays: parseInt(crew.working_days),
                nonWorkingDays: parseInt(crew.non_working_days),
                selectedFields: crew.geo_region_list,
                workPlanMethodId: crew.work_plan_method_id,
                targetPlanType: crew.target_plan_type ? crew.target_plan_type : 2,
                truckRate: (crew.truck_rate_uuid && crew.truck_rate_uuid !== null && crew.truck_rate_uuid !== "null") ? crew.truck_rate_uuid : 'default_option',
                semiTruckRate: (crew.semi_truck_rate_uuid && crew.semi_truck_rate_uuid !== null && crew.semi_truck_rate_uuid !== "null") ? crew.semi_truck_rate_uuid : 'default_option',
                isAllShapes: crew.is_active_all_shapes ? crew.is_active_all_shapes : false
            });
        }
    }, [isEditMode, crew]);

    useEffect(() => {
        if (planTypeId === 5) setState({ ...state, loadType: 2, isNoWorkPlan: true });
        if (planTypeId === 2) setState({ ...state, loadType: 2 });
    }, [planTypeId]);

    const bindCrewInfo = () => {
        const isNoWorkPlan = !crew.is_work_plan;
        const plannedSpec = {
            plannedAcres: unit.toArea(parseFloat(crew.acres), 2),
            isManualPlannedAcre: Boolean(crew.is_manual_planned_acres),
            utilization: crew.utilization ? Math.ceil(crew.utilization) : 40,
            avgWorkingSpeed: unit.toSpeed(parseFloat(crew.avg_working_speed), 2),
            workingHoursPerDay: parseFloat(crew.working_hours_per_day),
            workingDays: parseInt(crew.working_days),
            nonWorkingDays: parseInt(crew.non_working_days),
            selectedFields: crew.geo_region_list
        };

        if (isNoWorkPlan) setPrevPlanned(defaultPlanned);
        let startDate = crew.plan_start_date ? toMoment(crew.plan_start_date) : null;
        if (startDate && startDate.year() === getDefaultMoment().year()) startDate = null;

        setState({
            ...state,
            ...plannedSpec,
            crewName: crew.crew_name,
            isNoWorkPlan: planTypeId === 5 ? true : isNoWorkPlan,
            startDate,
            endCrewDate: (crew.is_end_crew && crew.end_crew_tz_date) ? moment.utc(crew.end_crew_tz_date) : null,
            isEndCrew: crew.is_end_crew,
            loadType: crew.load_type,
            acresPerDay: crew.acres_per_day,
            workPlanMethodId: crew.work_plan_method_id ? crew.work_plan_method_id : 1,
            targetPlanType: crew.target_plan_type ? crew.target_plan_type : 2,
            truckRate: crew.truck_rate_uuid ? crew.truck_rate_uuid : 'default_option',
            semiTruckRate: crew.semi_truck_rate_uuid ? crew.semi_truck_rate_uuid : 'default_option',
            isAllShapes: crew.is_active_all_shapes ? crew.is_active_all_shapes : false
        });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    }

    const handleDouble = (event) => {
        const { name, value } = event.target;
        let onlyNums = value.replace(/[^0-9.]/g, '').toString();
        setState({ ...state, [name]: onlyNums });
    }

    const handleNumber = (event) => {
        const { name, value } = event.target;
        const onlyNums = value.replace(/[^0-9]/g, '');
        setState({ ...state, [name]: onlyNums });
    }

    const handleDate = (keyName, value) => {
        setState({ ...state, [keyName]: value });
    }

    const handleBlur = () => {
        isValidateWorkPlan();
    }

    const handleNoWorkPlan = (e) => {
        const { checked, name } = e.target;
        if (checked) {
            setPrevPlanned({
                plannedAcres: state.plannedAcres,
                acresPerDay: state.acresPerDay,
                loadType: state.loadType,
                isManualPlannedAcre: state.isManualPlannedAcre,
                utilization: state.utilization,
                avgWorkingSpeed: state.avgWorkingSpeed,
                workingHoursPerDay: state.workingHoursPerDay,
                workingDays: state.workingDays,
                nonWorkingDays: state.nonWorkingDays,
                selectedFields: state.selectedFields,
                isNoWorkPlan: state.isNoWorkPlan,
                workPlanMethodId: state.workPlanMethodId,
                targetPlanType: state.targetPlanType ? state.targetPlanType : 2,
                truckRate: state.truckRate,
                semiTruckRate: state.semiTruckRate

            });
            setState({ ...state, [name]: checked, ...clearPlanned, validateGroup: 'common' });
        }
        else {
            setState({ ...state, ...prevPlanned, [name]: checked });
            isValidateWorkPlan();
        }
    }

    const isValidateWorkPlan = () => {
        if (state.isNoWorkPlan) return;
        const validateGroup = "workplan";
        const validation = validator.validate(state, validateGroup);
        setState({ ...state, validation, validateGroup });
        setSubmitted(true);
        return validation.isValid;
    };

    const handleEndCrew = () => {
        if (window.confirm("You should only stop this crew when you are done using this work plan for the season. Are you sure?")) {
            dispatch(updateEndCrew(crew.crew_uuid));
            onHide();
        }
    }

    const saveCrew = () => {
        const s = state;
        const validateGroup = s.isNoWorkPlan ? 'common' : null;
        const validation = validator.validate(s, validateGroup);

        setState({ ...state, validation, validateGroup });
        setSubmitted(true);

        if (validation.isValid) {
            const params = {
                crew_name: s.crewName,
                plan_type_id: planTypeId,
                is_work_plan: !(s.isNoWorkPlan),
                acres: unit.fromArea(parseFloat(s.plannedAcres)),
                is_manual_planned_acres: s.workPlanMethodId === 1 ? true : false,
                utilization: Math.ceil(s.utilization),
                avg_working_speed: unit.fromSpeed(parseFloat(s.avgWorkingSpeed)),
                working_hours_per_day: parseFloat(s.workingHoursPerDay),
                working_days: Number(s.workingDays) ? parseInt(s.workingDays) : 0,
                non_working_days: Number(s.nonWorkingDays) ? parseInt(s.nonWorkingDays) : 0,
                plan_start_date: s.startDate ? toApiDateString(s.startDate) : toApiDateString(getDefaultMoment()),
                end_crew_tz_date: s.endCrewDate ? toApiDateString(s.endCrewDate) : null,
                geo_region_list: s.selectedFields ? s.selectedFields : [],
                load_type: s.loadType,
                work_plan_method_id: s.workPlanMethodId,
                acres_per_day: parseInt(s.acresPerDay),
                target_plan_type: planTypeId === 5 ? s.targetPlanType : null,
                truck_rate_uuid: (s.truckRate && s.truckRate !== "default_option") ? s.truckRate : null,
                semi_truck_rate_uuid: (s.semiTruckRate && s.semiTruckRate !== "default_option") ? s.semiTruckRate : null,
                is_active_all_shapes: s.isNoWorkPlan ? s.isNoWorkPlan : s.isAllShapes ? s.isAllShapes : false
            };

            const crewId = crew ? props.crewId : uuid();

            if (crew) dispatch(updateCrew(crewId, params));
            else dispatch(createCrew(crewId, params));
            if (!(s.isNoWorkPlan)) dispatch(getWorkPlan([crewId]));
            onHide();
        }
    }

    const handleChoose = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: parseInt(value) });
    };

    const s = state;
    const validateGroup = s.isNoWorkPlan ? 'common' : null;
    const v = submitted ? validator.validate(state, validateGroup) : state.validation;
    const noWorkPlanProps = s.isNoWorkPlan ? { defaultChecked: true } : {};
    const isEventDisable = planTypeId === 5 ? true : isEditMode && crew.is_end_crew;
    const rateScheduleList = useSelector((state) => state.rateSchedule.rateScheduleList);
    const [rateOptions, setRateOptions] = useState([]);

    const handleTypeChange = (e, fieldName) => {
        const value = e && (e !== null || e !== 'null') && e.value ? e.value : '';

        if (value !== null) {
            setState((prevState) => ({
                ...prevState,
                [fieldName]: value ? value : '',
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [fieldName]: '',
            }));
        }
    };

	useEffect(() => {
		const defaultOptions = {
			value: 'default_option',
			label: "None"
		}
		if (rateScheduleList && rateScheduleList.length > 0) {
			const rates = rateScheduleList.filter((e) => e.rate_schedule_applicable === 1).map((e) => {
				return {
					label: e.rate_name,
					value: e.rate_uuid
				}
			})
			setRateOptions([defaultOptions, ...rates])
		} else {
			setRateOptions([defaultOptions])
		}
	}, [rateScheduleList])

    return <Modal show={show} onHide={onHide} backdrop="static" className="crew-modal-form" size={"lg"} >
        <Modal.Header closeButton>
            <Modal.Title>{`${crew ? s.crewName : "Add crew"}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="h-100">
                <Col lg={4} md={4} sm={4} className="h-100 crew-form-view">
                    <div className={isEventDisable ? 'event-disabled' : ''}>
                        <Row className={`no-operation mx-0 ${s.isNoWorkPlan ? 'active' : ''}`}>
                            <Col md={11}>
                                <b>No work plan for this crew</b><br />
                                (actual work is always tracked)
                            </Col>
                            <Col md={1}>
                                <input type="checkbox" {...noWorkPlanProps} name='isNoWorkPlan' onClick={handleNoWorkPlan} className="float-right ml-2 mt-2" />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Validator validation={v.crewName}>
                                    <Form.Label htmlFor="txtCrewName">Crew Name<Validator.Mand /></Form.Label>
                                    <Form.Control type="text" id="txtCrewName" name="crewName" placeholder="Enter the crew name"
                                        maxLength='50' value={s.crewName} onChange={handleChange} autoComplete="off" />
                                    <Validator.Text />
                                </Validator>
                            </Form.Group>
                            <div>
                                <Form.Group className={s.isNoWorkPlan || (isEventDisable) ? 'event-disabled' : ''}>
                                    <Validator validation={v.startDate}>
                                        <Form.Label htmlFor="dpStartDate">Start Date<Validator.Mand /></Form.Label>
                                        <Datetime id="dpStartDate" placeholder="Select start date" name="startDate" closeOnSelect={true}
                                            dateFormat={DISPLAY_DATE_FORMAT} timeFormat={false} onChange={handleDate.bind(this, "startDate")}
                                            value={state.startDate} selected={state.startDate} autoComplete="off" />
                                        <Validator.Text />
                                    </Validator>
                                </Form.Group>
                                {
                                    planTypeId === 5 && <Form.Group >
                                        <Form.Label>Target Plan Type<Validator.Mand /></Form.Label>
                                        <Row className="ml-3 mt-2 work-plan">
                                            {
                                                PLAN_TYPE_LIST.filter((e) => ![10].includes(e.plan_type_id)).map((item) => (
                                                    <Form.Check
                                                        key={item.plan_type_id}
                                                        type="radio"
                                                        name="targetPlanType" value={item.plan_type_id}
                                                        inline
                                                        label={item.plan_type}
                                                        id={item.plan_type_id}
                                                        checked={state.targetPlanType === item.plan_type_id}
                                                        onChange={e => handleChoose(e)}
                                                        style={{ marginRight: "10px" }} />
                                                ))
                                            }
                                        </Row>
                                    </Form.Group>
                                }
                                <Form.Group className={s.isNoWorkPlan || (isEventDisable) ? 'event-disabled' : ''}>
                                    <Form.Label>Load Type<Validator.Mand /></Form.Label>
                                    <Row className="ml-3 mt-2 work-plan">
                                        <Form.Check
                                            type="radio"
                                            name="loadType" value={1}
                                            inline
                                            label="Automatic"
                                            id="automatic"
                                            checked={state.loadType === 1}
                                            onChange={e => handleChoose(e)}
                                            style={{ marginRight: "6px" }} />
                                        <i
                                            className="fa fa-info"
                                            style={{ marginTop: "1px", color: "#9e9e9e" }}
                                            aria-hidden="true"
                                            title="Automated load tracking tracks more general load information  such as field and offload site."
                                        />
                                        <Form.Check
                                            type="radio"
                                            name="loadType"
                                            value={2} inline
                                            label="Manual"
                                            id="manual"
                                            checked={state.loadType === 2}
                                            onChange={e => handleChoose(e)}
                                            className="ml-4"
                                            style={{ marginRight: "6px" }} />
                                        <i
                                            className="fa fa-info"
                                            style={{ marginTop: "1px", color: "#9e9e9e" }}
                                            aria-hidden="true"
                                            title="Manual load tracking requires 2 taps from the operator 
                                            1. select the truck 
                                            2. end the load
                                               This provides more granular traceability, such as load location in the field."
                                        />
                                    </Row>
                                </Form.Group>
                                <div className={s.isNoWorkPlan || (isEventDisable) ? 'event-disabled' : ''}>
                                    <Form.Group>
                                        <Form.Label><b>Work Plan</b><Validator.Mand /></Form.Label>
                                        <Row className="ml-3 work-plan">
                                            <Form.Check
                                                type="radio"
                                                name="workPlanMethodId" value={1}
                                                label="I know the total planned acres for the crew"
                                                inline
                                                checked={state.workPlanMethodId === 1}
                                                onChange={e => handleChoose(e)}
                                                className="col-md-12 mt-2 mb-2" />
                                            <Form.Check
                                                type="radio"
                                                name="workPlanMethodId"
                                                value={2}
                                                inline
                                                label="I know the field(s) for the crew"
                                                checked={state.workPlanMethodId === 2}
                                                onChange={e => handleChoose(e)}
                                                className="col-md-12 mt-2 mb-2" />
                                            <Form.Check
                                                type="radio"
                                                name="workPlanMethodId"
                                                value={3}
                                                inline
                                                label="I know the daily planned acres for the crew"
                                                checked={state.workPlanMethodId === 3}
                                                onChange={e => handleChoose(e)}
                                                className="col-md-12 mt-2 mb-2" />
                                        </Row>
                                    </Form.Group>
                                    <Form.Group className="ml-4">
                                        <Validator validation={v.plannedAcres}>
                                            <Form.Label htmlFor="txtPlannedArea"> Planned Total {settings.areaShortName}<Validator.Mand /></Form.Label>
                                            <InputGroup>
                                                <Form.Control disabled={state.workPlanMethodId !== 1} type="text" id="txtPlannedAcres" name="plannedAcres" placeholder={`Enter the planned ${settings.areaShortName}`}
                                                    onChange={handleDouble} onBlur={handleBlur} maxLength='20' value={s.plannedAcres} autoComplete="off" />
                                                <InputGroup.Append>
                                                    <InputGroup.Text>{settings.areaShortName}</InputGroup.Text>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <Validator.Text />
                                        </Validator>
                                    </Form.Group>
                                    <Form.Group className="ml-4">
                                        <Validator validation={v.utilization}>
                                            <Form.Label htmlFor="txtPlannedArea">Planned Utilization<Validator.Mand /></Form.Label>
                                            <InputGroup>
                                                <Form.Control disabled={state.workPlanMethodId === 3} type="text" id="txtUtilization" name="utilization" placeholder="Enter the utilization"
                                                    onChange={handleDouble} onBlur={handleBlur} maxLength='5' value={s.utilization} autoComplete="off" />
                                                <InputGroup.Append>
                                                    <InputGroup.Text>%</InputGroup.Text>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <Validator.Text />
                                        </Validator>
                                    </Form.Group>
                                    {state.workPlanMethodId === 3 && <Form.Group className="ml-4">
                                        <Validator validation={v.acresPerDay}>
                                            <Form.Label htmlFor="txtPlannedArea">Planned Daily {settings.areaShortName}<Validator.Mand /></Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" id="txtTargetAcres" name="acresPerDay" placeholder={`Enter the Daily ${settings.areaShortName}`}
                                                    onChange={handleDouble} onBlur={handleBlur} maxLength='20' value={s.acresPerDay} autoComplete="off" />
                                                <InputGroup.Append>
                                                    <InputGroup.Text>{settings.areaShortName}</InputGroup.Text>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <Validator.Text />
                                        </Validator>
                                    </Form.Group>}
                                    {state.workPlanMethodId === 3 && <Form.Group className="ml-4">
                                        {/* <Validator validation={v.workingDays}> */}
                                        <Form.Label htmlFor="txtPlannedArea">Planned Number of Working days<Validator.Mand /></Form.Label>
                                        <InputGroup>
                                            <Form.Control type="text" id="txtWorkingDays" name="workingDays" placeholder={`Enter the working days`}
                                                onChange={handleNumber} onBlur={handleBlur} maxLength='20' value={s.workingDays} autoComplete="off" />
                                            <InputGroup.Append>
                                                <InputGroup.Text>Days</InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                        {/* <Validator.Text />
										</Validator> */}
                                    </Form.Group>}
                                    <Form.Group className="ml-4">
                                        <Validator validation={v.avgWorkingSpeed}>
                                            <Form.Label htmlFor="txtAvgWorkingSpeed">Planned Avg. Working Speed<Validator.Mand /></Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" id="txtAvgWorkingSpeed" name="avgWorkingSpeed" placeholder="Enter the avg. working speed"
                                                    onChange={handleDouble} onBlur={handleBlur} maxLength='5' value={s.avgWorkingSpeed} autoComplete="off" />
                                                <InputGroup.Append>
                                                    <InputGroup.Text>{settings.speedShortName}</InputGroup.Text>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <Validator.Text />
                                        </Validator>
                                    </Form.Group>
                                    <Form.Group className="ml-4">
                                        {/* <Validator validation={v.workingHoursPerDay}> */}
                                        <Form.Label htmlFor="txtWorkingHoursPerDay">Planned Working Hours Per Day<Validator.Mand /></Form.Label>
                                        <InputGroup>
                                            <Form.Control type="text" id="txtWorkingHoursPerDay" name="workingHoursPerDay" placeholder="Enter the working hours per day"
                                                onChange={handleDouble} onBlur={handleBlur} maxLength='3' value={s.workingHoursPerDay} autoComplete="off" />
                                            <InputGroup.Append>
                                                <InputGroup.Text>Hours</InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                        {/* <Validator.Text />
										</Validator> */}
                                    </Form.Group>
                                    <Form.Group className="ml-4">
                                        <Validator validation={v.nonWorkingDays}>
                                            <Form.Label htmlFor="txtNonWorkingDays">Planned Non-Working Days<Validator.Mand /></Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" id="txtNonWorkingDays" name="nonWorkingDays" placeholder="Enter the non-working days"
                                                    onChange={handleNumber} onBlur={handleBlur} maxLength='3' value={s.nonWorkingDays} autoComplete="off" />
                                                <InputGroup.Append>
                                                    <InputGroup.Text>Days</InputGroup.Text>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <Validator.Text />
                                        </Validator>
                                    </Form.Group>
                                </div>
                            </div>
                            {crew && crew.is_end_crew && <Form.Group>
                                <Validator validation={v.endCrewDate}>
                                    <Form.Label htmlFor="dpEndCrewDate">End Crew Date<Validator.Mand /></Form.Label>
                                    <Datetime id="dpEndCrewDate" placeholder="Select end crew date" name="endCrewDate" closeOnSelect={true}
                                        dateFormat={DISPLAY_DATE_FORMAT} timeFormat={true} onChange={handleDate.bind(this, "endCrewDate")}
                                        value={state.endCrewDate} selected={state.endCrewDate} autoComplete="off" />
                                    <Validator.Text />
                                </Validator>
                            </Form.Group>}
                        </Col>
                    </Row>
                </Col>
                <Col className="h-100">
                    <FieldSelection state={state} handleState={setState} />
                </Col>
            </Row>
            <Row className="mx-0 rate_container">
                <Col sm={12} lg={12}>
                    <Row className="mx-0 mt-4">
                        <Col sm={4} lg={4}>
                            <h6>Rates</h6>
                            <Form.Group>
                                {/* <Validator validation={v.truckRate}> */}
                                <Form.Label htmlFor="truckRate">Truck Rate</Form.Label>
                                <Form.Select
                                    id="truckRate"
                                    placeholder="Select Rate Type"
                                    name="truckRate"
                                    onChange={(e) => handleTypeChange(e, 'truckRate')}
                                    value={state.truckRate || ''}
                                    options={rateOptions}
                                >
                                </Form.Select>
                                {/* <Validator.Text />
								</Validator> */}
                            </Form.Group>
                            <Form.Group>
                                {/* <Validator validation={v.semiTruckRate}> */}
                                <Form.Label htmlFor="semiTruckRate">Semi Truck Rate</Form.Label>
                                <Form.Select
                                    id="semiTruckRate"
                                    placeholder="Select Rate Type"
                                    name="semiTruckRate"
                                    onChange={(e) => handleTypeChange(e, 'semiTruckRate')}
                                    value={state.semiTruckRate || ''}
                                    options={rateOptions}
                                />
                                {/* <Validator.Text />
								</Validator> */}
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            {isEditMode && <Col className="p-0">
                {crew.is_end_crew
                    ? <div className="d-flex display-end-date">
                        <p>Ended @ {moment.utc(crew.end_crew_tz_date).format(DISPLAY_DATETIME_FORMAT2)}</p>
                    </div>
                    : <>
                        <Button variant="danger mr-2" size="sm" onClick={handleEndCrew}>
                            <i className="fa fa-ban"></i> End Crew
                        </Button>
                        <i
                            className="fa fa-info-circle i-card"
                            aria-hidden="true"
                            title={"You should only stop this crew when you are done using this work plan for the season."}
                        />
                    </>}
            </Col>}
            <Col className="p-0">
                <Button variant="primary" size="sm" className="float-right mx-1" onClick={saveCrew}>
                    <i className="fa fa-floppy-o"></i> Add
                </Button>
                <Button variant="danger" size="sm" className="float-right mx-2" onClick={onHide}>
                    <i className="fa fa-times-circle"></i> Cancel
                </Button>
            </Col>
        </Modal.Footer>
    </Modal>;
};

export default CrewForm;